import { Color, MeshLambertMaterial, MeshStandardMaterial } from "three"

export default function setEmissiveWindowMaterial(
  material: MeshStandardMaterial | MeshLambertMaterial,
  emissiveColor: Color
): void {
  // console.log('expecting MeshStandardMaterial', material)
  material.emissive = emissiveColor // Emissive color
  material.emissiveIntensity = 1 // Controls brightness
  if (material instanceof MeshStandardMaterial) {
    material.roughness = 0.5
    material.metalness = 0.1
  }
}
